import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

import styles from './loadingDropdownItem.module.scss';

export const LoadingDropdownItem = () => (
  <FlexBox alignItems="center" justifyContent="center" className={styles.root}>
    <Spinner size={16} />
  </FlexBox>
);
